import {
  USER_ID_LIST_REQUEST,
  USER_ID_LIST_SUCCESS,
  USER_ID_LIST_FAILURE,
} from "../actions/userActions";

const initialState = {
  loading: false,
  userList: [],
  error: null,
};

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_ID_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case USER_ID_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        userList: action.payload,
      };

    case USER_ID_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
